import { Directive, ElementRef, HostListener } from '@angular/core';

// Stops the mouse wheel from incrementing/decrementing number inputs.
// Blurring the field lets the page keep scrolling normally while the value stays put.
@Directive({
    selector: 'input[type=number]',
    standalone: true
})
export class NoScrollNumberDirective {
    constructor(private el: ElementRef<HTMLInputElement>) { }

    @HostListener('wheel')
    onWheel() {
        if (document.activeElement === this.el.nativeElement) {
            this.el.nativeElement.blur();
        }
    }
}
